import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { size, fade, easing, foundation_time, foundation_fade } = ids || {};
export const InputContainer = styled.div `
  display: flex;
  flex: 1 1 auto;
  width: 100%;
`;
export const SearchBarContainer = styled.div `
  ${fade.base.ids_fade_general_in};
  ${fade.base.ids_fade_general_out};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${size.general.ids_size_general_12x};
  flex: 1 1 auto;
  width: 100%;

  .searchbar-fade-in-start {
    opacity: ${foundation_fade.fade.fade_0};
  }

  button.searchbar-fade-in-start {
    width: 0;
    padding: 0;
  }

  .searchbar-fade-in-moderate-end {
    opacity: ${foundation_fade.fade.fade_100};
    transition: all ${foundation_time.moderate.time_moderate_300ms}
      ${easing.expressive.inOut.ids_easing_expressive_standard};
  }

  button.searchbar-fade-in-moderate-end {
    width: ${size.general.ids_size_general_56x};
  }

  .searchbar-fade-out-start {
    opacity: ${foundation_fade.fade.fade_100};
  }

  button.searchbar-fade-out-start {
    width: ${size.general.ids_size_general_56x};
  }

  .searchbar-fade-out-moderate-end {
    opacity: ${foundation_fade.fade.fade_0};
    transition: all ${foundation_time.moderate.time_moderate_300ms}
      ${easing.expressive.inOut.ids_easing_expressive_standard};
  }

  button.searchbar-fade-out-moderate-end {
    padding: 0;
    width: 0;
  }
`;
//# sourceMappingURL=SearchBar.style.js.map